// extracted by mini-css-extract-plugin
module.exports = {"block":"MakePhoto_block__1xpNf","textItem":"MakePhoto_textItem__R8Wh2","icon":"MakePhoto_icon__15w3z"};